// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from '@mui/lab';
import { timelineOppositeContentClasses } from '@mui/lab/TimelineOppositeContent';
import {
  Pagination, Stack, Typography,
} from '@mui/material';
// import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React, { useState } from 'react';

import parseDateString from '../../../utils/parseDateString';
// import { ProductTypeContext } from './ProductTypeContext';

function ProductTypeLogs({
  handleChangePage,
  handleChangeItemsPerPage,
  logs,
  count,
  page,
  logsPerPage,
}) {
  const [expandedLogs, setExpandedLogs] = useState([]);
  const handleExpandClick = (logId) => {
    setExpandedLogs((prevExpandedLogs) => {
      if (prevExpandedLogs.includes(logId)) {
        return prevExpandedLogs.filter((log) => log !== logId);
      }
      return [...prevExpandedLogs, logId];
    });
  };

  return (
    <div style={{ marginTop: '-7px', marginLeft: '1px', marginRight: '1px' }}>
      <div className="py-2 bg-white border">
        {logs.length > 0 ? (
          <Timeline
            sx={{
              [`& .${timelineOppositeContentClasses.root}`]: {
                flex: 'none',
                width: '110px',
              },
            }}
          >
            {logs.map((log) => {
              const jsonStartIndex = log.Message.indexOf('[');
              const jsonEndIndex = log.Message.lastIndexOf(']') + 1;
              const nonJsonMessage = log.Message.substring(0, jsonStartIndex);
              let jsonString = log.Message.substring(jsonStartIndex, jsonEndIndex);
              jsonString = jsonString.replace(/,\s*([\]}])/g, '$1');
              const parsedJson = JSON.parse(jsonString || null);
              if (jsonStartIndex !== -1 && jsonEndIndex !== -1) {
                try {
                  const isExpanded = expandedLogs.includes(log.Created);
                  return (
                    <TimelineItem key={log.logId}>
                      <TimelineOppositeContent style={{ padding: '2px 10px 6px 10px' }}>
                        <Stack>
                          <Typography variant="body2" style={{ color: '#6f7686' }}>
                            {parseDateString(log.Created)}
                          </Typography>
                        </Stack>
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        <CheckCircleIcon sx={{ color: '#1aa0b3' }} />
                        <TimelineConnector sx={{ backgroundColor: '#1aa0b3' }} />
                      </TimelineSeparator>
                      <TimelineContent style={{ padding: '0 10px 6px 10px' }}>
                        <Typography>{nonJsonMessage}</Typography>
                        {isExpanded ? (
                          <>
                            <Typography className="cursor-pointer text-primary-600" onClick={() => handleExpandClick(log.Created)}>
                              Show less
                            </Typography>
                            <pre className="whitespace-pre-wrap">{JSON.stringify(parsedJson, null, 2)}</pre>
                          </>
                        ) : (
                          <Typography className="cursor-pointer text-primary-600" onClick={() => handleExpandClick(log.Created)}>
                            Show more
                          </Typography>
                        )}
                        <Typography className="flex items-center" variant="body2" style={{ color: '#6f7686' }}>
                          <PersonOutlineIcon style={{ color: '#6f7686', marginRight: '5px' }} fontSize="small" />
                          {' '}
                          {log.UserName}
                        </Typography>
                      </TimelineContent>
                    </TimelineItem>
                  );
                } catch (error) {
                  console.error('Error parsing JSON:', error);
                  return null;
                }
              } else {
                return (
                  <TimelineItem key={log.created} className="{margin:0,padding:0}">
                    <TimelineOppositeContent style={{ padding: '0px 0px 0px 0px' }}>
                      <Stack>
                        <Typography variant="body2" style={{ color: '#6f7686' }}>
                          {parseDateString(log.Created)}
                        </Typography>
                      </Stack>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <CheckCircleIcon sx={{ color: '#1aa0b3' }} />
                      <TimelineConnector sx={{ backgroundColor: '#1aa0b3' }} />
                    </TimelineSeparator>
                    <TimelineContent style={{ padding: '0 16px 6px 16px' }}>
                      <Typography>{log.Message}</Typography>
                      <Typography className="flex items-center break-all min-w-[165px]" variant="body2" style={{ color: '#6f7686' }}>
                        <PersonOutlineIcon style={{ color: '#6f7686', marginRight: '5px' }} fontSize="small" />
                        {' '}
                        {log.UserName}
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                );
              }
            })}
          </Timeline>
        ) : <Typography className="pl-4">No results found</Typography>}
      </div>
      <div className="flex flex-col items-center gap-6 p-2 pl-4 bg-white border rounded-lg sm:flex-row w-[98%]
          absolute bottom-0 right-0 m-1 shadow-md"
      >
        <FormControl sx={{ minWidth: 120 }} variant="standard" size="small" className="flex flex-row items-center">
          <Typography variant="body2" className="mr-4">Rows per page:</Typography>
          <Select
            labelId="logs-per-page"
            value={logsPerPage}
            onChange={handleChangeItemsPerPage}
            autoWidth
            size="small"
            variant="standard"
          >
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={15}>15</MenuItem>
          </Select>
        </FormControl>
        <Pagination
          count={count}
          page={page}
          onChange={handleChangePage}
        />
      </div>
    </div>
  );
}

export default ProductTypeLogs;
